import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type UpdateBettieSatisfactionBody = NonNullable<
  paths['/api/v1/chat_rooms/{chat_room_id}/feedbacks']['post']['requestBody']
>['content']['application/json'];

export type UpdateBettieSatisfactionResponse =
  paths['/api/v1/chat_rooms/{chat_room_id}/feedbacks']['post']['responses'][201]['content']['application/json']['chatRoomFeedback'];

export type ChatRoomDetailResponse =
  paths['/api/v1/chat_rooms/{id}']['get']['responses'][200]['content']['application/json']['chatRoom'];

export type CreateChatRoomBody = NonNullable<
  paths['/api/v1/chat_rooms']['post']['requestBody']
>['content']['application/json'];
export type CreateChatRoomResponse =
  paths['/api/v1/chat_rooms']['post']['responses'][200]['content']['application/json']['chatRoom'];

export type GetChatRoomsQuery =
  paths['/api/v1/chat_rooms']['get']['parameters']['query'];
export type GetChatRoomsListResponse =
  paths['/api/v1/chat_rooms']['get']['responses'][200]['content']['application/json'];
export interface GetChatRoomsListParams {
  query: GetChatRoomsQuery;
}
export interface GetRecentChatRoomByTradingPhotoCardParams {
  tradingPhotoCardId: string;
}

function serializeChatRoomsQuery(query: GetChatRoomsQuery = {}): string {
  const search = new URLSearchParams();

  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === false) continue;
    if (Array.isArray(value)) {
      for (const item of value) {
        search.append(`${key}[]`, String(item));
      }
    } else {
      search.append(key, String(value));
    }
  }

  return search.toString();
}

export async function updateBettieSatisfaction({
  body,
  chatRoomId
}: {
  body: UpdateBettieSatisfactionBody;
  chatRoomId: string;
}): Promise<UpdateBettieSatisfactionResponse> {
  const { data, error } = await client.POST('/api/v1/chat_rooms/{chat_room_id}/feedbacks', {
    headers: authHeaders(),
    params: {
      path: {
        chat_room_id: chatRoomId
      }
    },
    body
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when updating bettie satisfaction');
  return data.chatRoomFeedback;
}

export async function getChatRoomDetail(chatRoomId: string): Promise<ChatRoomDetailResponse> {
  const { data, error } = await client.GET('/api/v1/chat_rooms/{id}', {
    headers: authHeaders(),
    params: {
      path: {
        id: chatRoomId
      }
    }
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting chat room detail');
  return data.chatRoom;
}

export async function createChatRoom(body: CreateChatRoomBody): Promise<CreateChatRoomResponse> {
  const { data, error } = await client.POST('/api/v1/chat_rooms', {
    headers: authHeaders(),
    body
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when creating chat room');
  return data.chatRoom;
}

export async function getChatRoomsList(
  params: GetChatRoomsListParams
): Promise<GetChatRoomsListResponse> {
  const { data, error } = await client.GET('/api/v1/chat_rooms', {
    headers: authHeaders(),
    params: {
      query: params.query
    },
    querySerializer: serializeChatRoomsQuery
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting chat rooms list');
  return data;
}

export async function getRecentChatRoomByTradingPhotoCard(
  params: GetRecentChatRoomByTradingPhotoCardParams
) {
  const result = await getChatRoomsList({
    query: {
      trading_photo_card_id: params.tradingPhotoCardId,
      per_page: 1
    }
  });
  return result.chatRooms[0] ?? null;
}